import * as React from "react";
import { useCookies } from "react-cookie";
import jMoment from "moment-jalaali";
// Utilities and hooks
import showNotify from "helpers/notify";
import { push } from "helpers/history";
// Shared components
import Maybe from "components/Maybe";
import Enamad from "components/Enamad";
// Local components
import { Result, Button as AntButton } from "antd";
import Main from "screens/Auth/components/Main";
import UserExist from "./components/UserExist";
import RegisterForm from "./components/RegisterForm";
import CodeValidation from "./components/CodeValidation";
import ExternalLinks from "screens/Auth/components/ExternalLinks";

// UI Frameworks
interface IState {
	firstName: string;
	lastName: string;
	mobile: string;
	email: string;
	code: string;
	password?: string;
	confirmPwd?: string;
	referralNumber?: string;
	coworker: boolean;
	rulesAcception: boolean;
	state: "init-password" | "registered" | "check-email" | "not-registered";
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAction extends Partial<IState> {}

function reducer(state: IState, action: IAction): IState {
	return { ...state, ...action };
}

const Register: React.FC = () => {
	const [cookies, setCookie, removeCookie] = useCookies(["mobileReg", "emailReg"]);
	const initialState = () =>
		({
			firstName: "",
			lastName: "",
			mobile: "",
			email: "",
			code: "",
			password: "",
			confirmPwd: "",
			referralNumber: "",
			coworker: false,
			rulesAcception: false,
			state: "not-registered",
		} as IState);
	const [store, dispatch] = React.useReducer(reducer, initialState());

	React.useEffect(() => {
		if (cookies.mobileReg) {
			dispatch({ mobile: cookies.mobileReg, state: "registered" });
		}
		if (cookies.emailReg) {
			dispatch({ email: cookies.emailReg, state: "check-email" });
		}
	}, [cookies.mobileReg, cookies.emailReg]);

	function handleRegisterSubmit(data: IState, mobileReg: boolean): void {
		dispatch(data);

		setCookie(mobileReg ? "mobileReg" : "emailReg", mobileReg ? data.mobile : data.email, {
			expires: jMoment()
				.add(5, "s")
				.toDate(),
			path: "/",
		});
	}

	function handleChangeMobile(): void {
		removeCookie("mobileReg");
		dispatch({ state: "not-registered" });
	}

	function handleChangeEmail(): void {
		removeCookie("emailReg");
		dispatch({ state: "not-registered" });
	}

	function handleCodeValidation(data: IState): void {
		dispatch({ ...data, state: "init-password" });
	}

	function handleInitPassword(data: IState): void {
		dispatch(data);
		showNotify({
			text: "ثبت نام با موفقیت انجام شد لطفا وارد شوید",
			duration: 3000,
		});
		push("/auth/login");
	}

	return (
		<React.Fragment>
			<Maybe condition={store.state === "not-registered"}>
				<Main title="ثبت نام" subTitle=" خوش آمدید! لطفا برای ثبت نام اطلاعات خود را وارد کنید">
					<UserExist store={store} onSubmit={handleRegisterSubmit} />
					<ExternalLinks login />
					<Enamad />
				</Main>
			</Maybe>
			<Maybe condition={store.state === "check-email"}>
				<Main title="ثبت نام">
					<Result
						status="success"
						title="ثبت نام با موفقیت انجام شد."
						subTitle="لطفا ایمیل خودرا چک کنید و درصورت عدم مشاهده در صندوق اصلی spam ایمیل خود مراجعه کنید."
					/>
					<div className="text-center">
						<AntButton type="link" style={{ padding: 0 }} onClick={handleChangeEmail}>
							تغییر ایمیل
						</AntButton>
					</div>
					<ExternalLinks login />
				</Main>
			</Maybe>
			<Maybe condition={store.state === "registered"}>
				<Main title="ثبت نام">
					<CodeValidation
						mobile={store.mobile}
						onChangeMobile={handleChangeMobile}
						onSubmit={handleCodeValidation}
					/>
					<ExternalLinks login />
				</Main>
			</Maybe>
			<Maybe condition={store.state === "init-password"}>
				<Main title="ثبت نام">
					<RegisterForm store={store} onSubmit={handleInitPassword} />
					<ExternalLinks login />
				</Main>
			</Maybe>
		</React.Fragment>
	);
};

export default React.memo(Register);
